// Shared college code → full name mapping.
// Previously duplicated in 5 separate files.
const COLLEGE_MAP = {
  main: "Delhi University",
  hrc: "Hansraj College",
  rjc: "Ramjas College",
  jcbust: "JC Bose UST",
  clc: "Campus Law Center",
  nitp: "NIT Patna",
  cu: "Chandigarh University",
  pu: "Punjab University",
  lpu: "Lovely Professional University",
  fot: "Faculty of Technology",
  cic: "Cluster Innovation Center",
  mhc: "Miranda House College",
  drc: "Daulat Ram College",
  kmc: "Kirori Mal College",
  arbc: "Aryabhatt College",
  lbc: "Laxmibai College",
  knc: "Kamla Nehru College",
  kmv: "Keshav Mahavidyalaya",
  srcc: "Shri Ram College of Commerce",
  other: "Other",
};

export default COLLEGE_MAP;
